import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactPropertiesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ContactProperties",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.03 28.48V3.52a1.52 1.52 0 1 0-3.04 0v24.96a1.52 1.52 0 1 0 3.04 0M12.52 17h.01c.2 0 .4-.04.58-.12h-.01l11.98-5c.55-.23.92-.76.92-1.38s-.37-1.15-.91-1.38h-.01l-11.98-5c-.16-.06-.34-.1-.53-.1a1.5 1.5 0 0 0-1.5 1.48v9.98c0 .83.67 1.5 1.5 1.5h-.05Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13 24.19c-.55 0-1-.45-1-1V5c0-.4.24-.77.62-.92.37-.16.8-.07 1.09.22C16.1 6.69 20.11 8.01 25 8.01c.38 0 .73.21.89.55s.13.74-.09 1.05c-.13.18-3.36 4.4-8.8 4.4-.55 0-1-.45-1-1s.45-1 1-1c2.47 0 4.41-1.11 5.66-2.1-3.43-.3-6.4-1.25-8.66-2.79V23.2c0 .55-.45 1-1 1Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19 28c-.37 0-.73-.21-.9-.57-.94-2-2.9-3.24-5.1-3.24s-4.15 1.24-5.1 3.24c-.24.5-.83.71-1.33.48-.5-.24-.71-.83-.48-1.33 1.26-2.66 3.97-4.38 6.9-4.38s5.64 1.72 6.9 4.38c.24.5.02 1.1-.48 1.33-.14.07-.28.1-.43.1Z"
      })]
    })
  }));
};